// *******************************************************************************
// Notification Bar
// *******************************************************************************

const notificationBar = document.querySelector('.notification-bar');

if (notificationBar) {
  const getNotificationBarHeight = () => {
    const notificationBarHeight = notificationBar.offsetHeight;
    document.body.classList.add('has-top-bar');
    document.body.style.setProperty('--top-bar-height', `${notificationBarHeight}px`);
  };

  const debounceGetNotificationBarHeight = debounce(() => {
    getNotificationBarHeight();
  }, 50);

  debounceGetNotificationBarHeight();

  window.addEventListener('resize', () => {
    debounceGetNotificationBarHeight();
  });

  if (!Cookies.get('notification-seen')) {
    notificationBar.classList.remove('is-hidden');
  }

  attachEvent('.notification-bar__close', 'click', (ev) => {
    const parentEle = ev.target.closest('.notification-bar');
    parentEle.classList.add('is-hidden');
    Cookies.set('notification-seen', true, { expires: 365 });
    document.body.style.setProperty('--top-bar-height', '0px');
  });
}
